/**
 * Kundenportal-Tracking Provider: Start + Page-View-Tracking
 *
 * Mountet den Tracking-Client in den Root der Kundenportal-Route.
 *
 * Datenschutz:
 * - Respektiert Do-Not-Track und localStorage-Opt-Out
 * - Daten werden 180 Tage gespeichert (Server-seitiger Retention-Job)
 * - Kill-Switch via CUSTOMER_PORTAL_TRACKING_ENABLED env-var
 * - Events nur gesendet, wenn Kill-Switch aktiv UND Browser-DNT aus
 *
 * Telemetrie-Typen: page_view, time_on_page, click, scroll, custom
 */
import { useEffect, type ReactNode } from 'react';
import { getTrackingClient } from './trackingClient';
import { useTrackPageView, useTimeOnPage, useScrollDepth } from './hooks';

interface TrackingProviderProps {
  children: ReactNode;
  /** Wenn false: gar kein Mounting (Kill-Switch per Parent) */
  enabled?: boolean;
}

export function TrackingProvider({ children, enabled = true }: TrackingProviderProps) {
  useEffect(() => {
    if (!enabled) return;
    const client = getTrackingClient();
    client.start();
    return () => client.stop();
  }, [enabled]);

  return enabled ? <TrackingInner>{children}</TrackingInner> : <>{children}</>;
}

function TrackingInner({ children }: { children: ReactNode }) {
  useTrackPageView();
  useTimeOnPage();
  useScrollDepth();
  return <>{children}</>;
}
